import LocomotiveScroll from "locomotive-scroll";
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';

const scroll = new LocomotiveScroll({
  el: document.querySelector("[data-scroll-container]"),
  smooth: true,
  tablet: {
    breakpoint: 0,
  },
  tablet: {
    breakpoint: 870,
    smooth: false,
  },
});

// Scroll update all pages

document.addEventListener("DOMContentLoaded", function () {
  function ScrollUpdateDelay() {
    setTimeout(function () {
      scroll.update();
    }, 500);
  }

  ScrollUpdateDelay();
});

function ScrollUpdateDelayGlobal() {
  setTimeout(function () {
    scroll.update();
  }, 300);
}

// Dropdown Home

const btnDrop = document.querySelector(".articles__dropdown__container");
const dropCheck = document.querySelector(".home__articles");
const overlay = document.querySelector(".overlay--articles");
const dropOpen = document.querySelector(".articles__drop__wrapper");

if (dropCheck) {
  btnDrop.addEventListener("click", () => {
    scroll.scrollTo("top", { offset: -20 });
    overlay.classList.add("open--drop");
    dropOpen.classList.add("open--drop");
  });
  overlay.addEventListener("click", () => {
    overlay.classList.remove("open--drop");
    dropOpen.classList.remove("open--drop");
  });
}


// arrows

scroll.on('scroll', (args) => {
  
  if(typeof args.currentElements['number1'] === 'object') {

    document.querySelector('.philo__arrow--1').classList.add('scrollShow');
    document.querySelector('.philo__number--1').classList.add('scrollShow');

  } if(typeof args.currentElements['number2'] === 'object') {

    document.querySelector('.philo__arrow--2').classList.add('scrollShow');
    document.querySelector('.philo__number--2').classList.add('scrollShow');

  } if(typeof args.currentElements['number3'] === 'object') {

    document.querySelector('.philo__arrow--3').classList.add('scrollShow');
    document.querySelector('.philo__number--3').classList.add('scrollShow');
  }
});


// Swiper config

var swiper = new Swiper(".mySwiper", {
    // configure Swiper to use modules
  modules: [Navigation, Pagination, Autoplay],
  autoplay: {
    delay: 4800,
    disableOnInteraction: true,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  }
});





// mobile menu

const btnMob = document.querySelector('.mobile-nav-btn');
const navMobActive = document.querySelector('.nav-mobil-on');


btnMob.addEventListener('click',  function() {

  btnMob.classList.toggle('active');
  navMobActive.classList.toggle('active-nav-mob');


})

// menu foot

const btnFootNav = document.querySelector('.mob--nav--foot');
const FootNavMenu = document.querySelector('.mob--nav--foot--open');
const btnFootNavClose = document.querySelector('.close--btn--foot');

btnFootNav.addEventListener('click',  function() {
  FootNavMenu.classList.toggle('activeFootNav');
})
btnFootNavClose.addEventListener('click',  function() {
  FootNavMenu.classList.toggle('activeFootNav');
})


// link home ancre

$(document).ready(function() {
  if (window.location.href.indexOf("patrimonial") > -1) { // check url
    
    scroll.scrollTo('#patrimonial', {'offset': -130});

  } else if (window.location.href.indexOf("finances") > -1) {

    scroll.scrollTo('#finances', {'offset': -130});

  } else if (window.location.href.indexOf("immo") > -1) {

    scroll.scrollTo('#immo', {'offset': -130});

  }
});
